(function () {
  const SWISH_SCRIPT_SRC = 'https://cdn.shopify.com/extensions/019ce26a-bb73-7ec7-a00f-cef8cb945806/swish-wishlist-king-220/assets/block-wishlist-button.js';
  let swishScriptPromise;

  function loadSwishScript() {
    if (customElements.get('wishlist-button-block')) return Promise.resolve();
    if (swishScriptPromise) return swishScriptPromise;

    swishScriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-joyee-swish-bridge]');
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = SWISH_SCRIPT_SRC;
      script.type = 'module';
      script.defer = true;
      script.setAttribute('data-joyee-swish-bridge', 'true');
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return swishScriptPromise;
  }

  function createBridgeMarkup(productHandle, variantId) {
    return `
      <wishlist-button-block
        data-product-handle="${productHandle}"
        data-variant-id="${variantId}"
        align-self="center"
        align-content="center"
        full-width="false"
        show-icon
        show-text="false"
      ></wishlist-button-block>
    `;
  }

  function initWishlistToggle(toggle) {
    if (!toggle || toggle.dataset.joyeeWishlistReady === 'true') return;
    toggle.dataset.joyeeWishlistReady = 'true';

    const container = toggle.closest('.product-title-container');
    const bridgeHost = container ? container.querySelector('[data-joyee-wishlist-bridge]') : null;
    const sectionId = toggle.dataset.sectionId;
    const productHandle = toggle.dataset.productHandle;
    const selectedVariant = sectionId ? document.getElementById(`SelectedVariant-${sectionId}`) : null;

    let mutationObserver;
    let buttonObserver;
    let bridgeHostObserver;
    let syncTimer;

    if (!container || !bridgeHost || !productHandle) return;

    function getVariantId() {
      return (selectedVariant && selectedVariant.dataset.variantId) || toggle.dataset.initialVariantId;
    }

    function getBridgeButton() {
      return bridgeHost.querySelector(
        'button.wk-button, wk-button button, button[aria-label], button[aria-pressed]'
      );
    }

    function getButtonState(swButton) {
      if (!swButton) return false;

      const label = (swButton.getAttribute('aria-label') || '').toLowerCase();
      const ariaPressed = (swButton.getAttribute('aria-pressed') || '').toLowerCase();
      const className = (swButton.className || '').toLowerCase();
      const dataState = (swButton.getAttribute('data-state') || '').toLowerCase();
      const dataAdded = (swButton.getAttribute('data-added') || '').toLowerCase();
      const text = (swButton.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();

      return (
        ariaPressed === 'true' ||
        label.includes('remove') ||
        label.includes('added') ||
        label.includes('in wishlist') ||
        text.includes('remove') ||
        text.includes('added') ||
        text.includes('in wishlist') ||
        className.includes('is-active') ||
        className.includes(' active') ||
        className.startsWith('active') ||
        className.includes('added') ||
        dataState === 'active' ||
        dataState === 'added' ||
        dataState === 'in-wishlist' ||
        dataAdded === 'true'
      );
    }

    function applyVisualState(isActive) {
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      toggle.setAttribute('aria-label', isActive ? 'Remove from Wishlist' : 'Add to Wishlist');
      toggle.classList.remove('is-loading');
    }

    function syncVisualState() {
      const bridgeButton = getBridgeButton();
      applyVisualState(getButtonState(bridgeButton));
    }

    function scheduleSync(attempts, delay) {
      let remaining = typeof attempts === 'number' ? attempts : 12;
      const interval = typeof delay === 'number' ? delay : 150;

      if (syncTimer) {
        window.clearTimeout(syncTimer);
      }

      function run() {
        syncVisualState();
        remaining -= 1;

        if (remaining > 0) {
          syncTimer = window.setTimeout(run, interval);
        }
      }

      run();
    }

    function watchBridgeButton() {
      if (buttonObserver) buttonObserver.disconnect();

      const bridgeButton = getBridgeButton();
      if (!bridgeButton) return;

      buttonObserver = new MutationObserver(() => {
        syncVisualState();
      });

      buttonObserver.observe(bridgeButton, {
        attributes: true,
        attributeFilter: ['aria-label', 'aria-pressed', 'class', 'data-state', 'data-added']
      });

      syncVisualState();
    }

    function watchBridgeHost() {
      if (bridgeHostObserver) bridgeHostObserver.disconnect();

      bridgeHostObserver = new MutationObserver(() => {
        watchBridgeButton();
        scheduleSync(10, 150);
      });

      bridgeHostObserver.observe(bridgeHost, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }

    function renderBridge() {
      const variantId = getVariantId();
      if (!variantId) return;

      bridgeHost.innerHTML = createBridgeMarkup(productHandle, variantId);

      window.requestAnimationFrame(() => {
        watchBridgeHost();
        watchBridgeButton();
        scheduleSync(16, 180);
      });
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      const bridgeButton = getBridgeButton();
      if (!bridgeButton) return;

      toggle.classList.add('is-loading');

      bridgeButton.click();

      scheduleSync(14, 160);
    });

    if (selectedVariant) {
      mutationObserver = new MutationObserver(() => {
        renderBridge();
      });

      mutationObserver.observe(selectedVariant, {
        attributes: true,
        attributeFilter: ['data-variant-id']
      });
    }

    loadSwishScript()
      .then(() => {
        renderBridge();
      })
      .catch(() => {
        toggle.classList.remove('is-loading');
      });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-joyee-wishlist-button]').forEach(initWishlistToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();